/**
 * `components.MuiPaper` — surfaces, elevation, rounded/outlined variants (menus, dialogs, cards).
 * Discoverability: `MuiPaper`, `elevation`, `Paper`, `styleOverrides.paper`.
 *
 * @see https://mui.com/material-ui/api/paper/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiPaper(theme: Theme): Pick<Components<Theme>, 'MuiPaper'> {
  return {
    MuiPaper: {
      styleOverrides: {
        outlined: {
          borderColor: theme.palette.border.light,
        },
        root: {
          backgroundImage: 'none',
        },
        rounded: {
          borderRadius: 12,
        },
      },
      defaultProps: {
        elevation: 8, // set to elevation 8 because right now menu/popover elevation aren't applying over the default '1' on paper
      },
    },
  };
}
